import { render, staticRenderFns } from "./TermConditions.vue?vue&type=template&id=1a13ffde&"
import script from "./TermConditions.vue?vue&type=script&lang=js&"
export * from "./TermConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports